import { iconGlyphs, type IconName } from "@bundle/tokens";
import { color as colorVar, size as sizeVar, type ColorToken } from "./tokens.ts";

export type IconProps = {
  name: IconName;
  size?: "icon.sm" | "icon.md" | "icon.lg";
  color?: ColorToken;
};

/** Glyph from the shared BundleIcons font (Lucide subset). Inherits color when `color` is absent. */
export function Icon({ name, size = "icon.md", color }: IconProps) {
  return (
    <span
      className="b-icon b-icon-glyph"
      aria-hidden
      style={{ fontSize: sizeVar(size), width: sizeVar(size), height: sizeVar(size), color: color === undefined ? undefined : colorVar(color) }}
    >
      {iconGlyphs[name]}
    </span>
  );
}
